import React from "react";
import { LanguageDropdownCommon } from "./";

interface LanguageDropdownProps {
  componentLabel?: string;
  defaultValue?: string;
  currentTeam?: string;
  required?: boolean;
  onChange?: (_event: any) => void;
}

/**
 * Language dropdown component
 * @param {object} props props
 * @returns {Element} React Component
 * @class
 */
export function LanguageDropdown(props: LanguageDropdownProps) {
  const dropdownProps: any = {
    componentLabel: props.componentLabel,
    defaultValue: props.defaultValue,
    visualStyle: "autoComplete",
    onChange: props.onChange,
  };

  if (props.required) {
    dropdownProps.required = props.required;
  }

  return <LanguageDropdownCommon {...dropdownProps} />;
}
